module.exports = __webpack_public_path__ + "5c114213/img/dollar-icon.35c9d638.svg";